import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./loginMotivation.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { storeAuthenticationContext } from '~/modules/analytics/authenticationContext';
import { WireI18n } from '~/modules/stores/i18nStore';
import { selectIsAuthenticated, userStore } from '~/modules/stores/userStore';
import { CookieConsentCategory, createCatCookie, getCookie } from '~/modules/utilities/cookies';
const BANNER_DISPLAY_DELAY_MS = 500;
const COOKIE_NAME = 'LoginSignupMotivation';
const COOKIE_DISMISS_VALUE = 'true';
class LoginMotivation extends LightningElement {
  constructor(...args) {
    super(...args);
    // @ts-expect-error * Automated Type Error Fix
    this.i18n = void 0;
    this.isAuthenticated = void 0;
    this.showMotivation = false;
  }
  get iconBrand() {
    return getComputedStyle(this.template.host).getPropertyValue('--sds-g-color-palette-blue-50');
  }
  saveAuthenticationContext() {
    storeAuthenticationContext({
      origin: 'toast'
    });
  }
  login() {
    this.saveAuthenticationContext();
    window.SFIDWidget.login();
  }
  signup() {
    this.saveAuthenticationContext();
    window.SFIDWidget.signup();
  }
  get shouldShowMotivation() {
    return !this.isAuthenticated && this.showMotivation;
  }
  getBannerOptOutState() {
    const optOutValue = getCookie(COOKIE_NAME);
    this.showMotivation = optOutValue !== COOKIE_DISMISS_VALUE;
  }
  close() {
    createCatCookie(COOKIE_NAME, COOKIE_DISMISS_VALUE, CookieConsentCategory.Functional);
    this.showMotivation = false;
  }
  connectedCallback() {
    // add delay to allow userStore to complete to prevent show/hide flicker if logged out banner is active
    // but user is logged in
    setTimeout(() => {
      this.getBannerOptOutState();
    }, BANNER_DISPLAY_DELAY_MS);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(LoginMotivation, {
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    },
    isAuthenticated: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectIsAuthenticated
        };
      }
    }
  },
  fields: ["showMotivation"]
});
const __lwc_component_class_internal = _registerComponent(LoginMotivation, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;